/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferCalculationStatusResponse } from '../../models/offer-calculation-status-response';

export interface GetOfferCalculationStatusByOfferRequestId$Params {
  offerRequestId: string;
}

export function getOfferCalculationStatusByOfferRequestId(http: HttpClient, rootUrl: string, params: GetOfferCalculationStatusByOfferRequestId$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferCalculationStatusResponse>> {
  const rb = new RequestBuilder(rootUrl, getOfferCalculationStatusByOfferRequestId.PATH, 'get');
  if (params) {
    rb.path('offerRequestId', params.offerRequestId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfferCalculationStatusResponse>;
    })
  );
}

getOfferCalculationStatusByOfferRequestId.PATH = '/offers/requests/{offerRequestId}/status';
